import { SvgIcon } from "@mui/material"

import { ReactComponent as CheckboxIcon } from "./indeterminateIcon.svg"

export const CheckboxIndeterminateIcon = (props) => {
    return (
        <SvgIcon component={CheckboxIcon} {...props} inheritViewBox />
    )
}

